<div class="row">
  <div class="column--12 column-md--6">
    <p class="description lineheight--loose">
      Upload a CSV of your customer's recent shipments. We'll add Machool's rate, dollar savings, and savings percent to
      each row so you can show them the difference.
    </p>
  </div>
</div>
<div class="row">
  <div class="column--12 column-md--6">
    <p>
      Not sure of the format? Download a
      <a class="sampleCsv" href="assets/rating-tool/rating-tool-sample.csv" download="rating-tool-sample.csv"
        >sample CSV</a
      >. Export the rated file once processing finishes.
    </p>
  </div>
</div>
<div class="row">
  <div class="column--12 column-md--6">
    <p>1. Upload CSV</p>
    <file-upload
      [fileFormControl]="ratingForm.get('file')"
      [buttonLabel]="'Upload CSV'"
      (uploadedFileEvent)="updateUploadedFile($event)"
    ></file-upload>
  </div>
</div>
<form [formGroup]="ratingForm" (ngSubmit)="fetchMachoolRates()">
  <p>2. Select courier and service</p>
  <div class="row" formGroupName="courier">
    <mat-form-field>
      <mat-label>Select courier</mat-label>
      <mat-select formControlName="courierEnum">
        @for (provider of providerList; track provider) {
        <mat-option [value]="provider.enum">{{ provider.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Select service</mat-label>
      <mat-select formControlName="service">
        @for (service of serviceOptions; track $index) {
        <mat-option [value]="service">{{ service.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <p>3. Add margin and select billing type</p>
  <div class="row">
    <mat-form-field>
      <mat-label>Margin rate (%)</mat-label>
      <mat-icon matSuffix>percent</mat-icon>
      <input matInput type="number" formControlName="margin" step="1" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Billing type</mat-label>
      <mat-select formControlName="billingType">
        @for (billingType of billingTypes; track billingType) {
        <mat-option [value]="billingType">{{billingTypeToString(billingType)}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="row">
    <p>
      <mat-checkbox formControlName="ignoreGlobalMargin">Ignore global margin</mat-checkbox>
    </p>
  </div>
  <button mat-flat-button color="primary" [disabled]="!ratingForm.valid || isFetching()" type="submit">
    Fetch Machool rates
  </button>
</form>

<div class="row" [style.visibility]="isFetching() ? 'visible' : 'hidden'">
  <div class="column--12 column-md--6 progress-container">
    <p>Progress: {{ jobStatus().progress }}%</p>
    <mat-progress-bar mode="buffer" [value]="jobStatus().progress" [bufferValue]="0"></mat-progress-bar>
  </div>
</div>

@if (submitError(); as message) {
<div class="row">
  <div class="column--12 column-md--6 job-summary job-summary--error">
    <mat-icon>error</mat-icon>
    <span>{{ message }}</span>
  </div>
</div>
}

@if (jobResult(); as result) {
<div class="row">
  <div class="column--12 column-md--6 job-summary">
    <div class="job-summary__counts">
      <span class="job-summary__count"> <mat-icon>check_circle</mat-icon>{{ result.success }} rated </span>
      <span class="job-summary__count" [class.job-summary__count--error]="result.error > 0">
        <mat-icon>error</mat-icon>{{ result.error }} failed
      </span>
      <span class="job-summary__count" [class.job-summary__count--warn]="result.skipped > 0">
        <mat-icon>skip_next</mat-icon>{{ result.skipped }} skipped
      </span>
    </div>
  </div>
</div>
<div class="row">
  <div class="column--12 column-md--6 job-summary__download">
    <a mat-stroked-button color="primary" [href]="result.downloadLink" target="_blank" rel="noopener">
      <mat-icon>download</mat-icon>Download rated CSV
    </a>
    @if (result.queued) {
    <span class="job-summary__note">Queued for Slack.</span>
    } @else {
    <span class="job-summary__note job-summary__note--warn">
      <mat-icon>warning</mat-icon>Couldn't queue the Slack post &mdash; use the download link.
    </span>
    }
  </div>
</div>
} @else if (jobStatus().state === 'failed') {
<div class="row">
  <div class="column--12 column-md--6 job-summary">
    <mat-icon>error</mat-icon>
    <span>Rating failed{{ jobStatus().failedReason ? ': ' + jobStatus().failedReason : '' }}</span>
  </div>
</div>
}

<div class="row disclaimer">
  Rate estimates are calculated using Machool’s rating engine and rounded to the nearest cent. Actual invoiced rates may
  vary based on fuel surcharges, residential fees, and dimensional weight adjustments applied at pickup.
</div>
